<i18n
  src="@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/pallets/empty_card.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div class="bg-white text-sm font-medium text-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500 cursor-pointer"
    :class="['overflow-hidden shadow-lg text-center h-[10rem] flex place-content-center pt-5', rounded_class]"
  >
    <a href="" @click.prevent="goToNew()" class="p-6 ">
      <i class="text-4xl fa-solid fa-plus"></i>
      <p class="text-lg">{{ $t("labels.new_link") }}</p>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Number,
      required: true
    },
    col: {
      type: Number,
      required: true
    },
    rounded_class: {
      type: String,
      default: "",
    },
  },
  components: {},
  computed: {
    packing_house_process_id: function () {
      return this.$router.currentRoute._value.params.packing_house_process_id;
    },
    container_id: function () {
      return this.$router.currentRoute._value.params.container_id;
    }
  },
  methods: {
    goToNew: function () {
      this.$router.push({
        name: this.routeName("new_package_group"),
        params: {
          packing_house_process_id: this.packing_house_process_id,
          container_id: this.container_id
        },
        query: { row: this.row, col: this.col }
      });
    }
  }
};
</script>
